// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3e2Ch","topBottomGutter":"Layout_topBottomGutter__sOEaB"};